import React from 'react';
import trim from 'mn-utils/trim';
import TextField from '../../../../../../dumb/TextField/I';
import Switch from '../../../../../../dumb/Switch/D';
import Select from '../../../../../../dumb/Select/H';


module.exports = (props) => {
  const state = props.value || {};
  const disableFullBlock = props.disableFullBlock;

  const enabled = state.enabled || false;
  const type = state.type;
  const username = state.username || '';
  const password = state.password || '';
  const token = state.token || '';
  const clicked = props.clicked && enabled;

  function setState(next) {
    props.onChange({
      ...state,
      ...next,
    });
  }

  return (
    <div className={props.className || ''}>
      <Switch
        className="cDADCE1"
        label={(
          <div className="c0 f15 fw5">{props.label}</div>
        )}
        checked={enabled && !disableFullBlock}
        onChange={(enabled) => {
          setState({
            enabled,
          });
        }}
        disabled={disableFullBlock}
      />
      <div
        className={'layoutRow fhaS fvaC mt20 dn o50 o100.enabled'
        + (enabled ? ' enabled' : '')}
      >
        <div className="pr10 w(|min)140">
          <Select
            placeholder="Type"
            displayEmpty
            items={props.items}
            value={type}
            error={clicked && !type}
            disabled={props.disabledSelect || !enabled || disableFullBlock || false}
            onChange={(type) => {
              setState({
                type,
              });
            }}
          />
        </div>
        {
          type === 'Basic' ? (
            <div className="layoutRow fhaS fvaC w1/2>1 fx1">
              <div>
                <TextField
                  label="Username"
                  error={clicked && !trim(username)}
                  value={username}
                  onChange={(e) => {
                    setState({
                      username: e.target.value,
                    });
                  }}
                  disabled={!enabled || disableFullBlock}
                />
              </div>
              <div className="pl10">
                <TextField
                  label="Password"
                  value={password}
                  onChange={(e) => {
                    setState({
                      password: e.target.value,
                    });
                  }}
                  disabled={!enabled || disableFullBlock}
                />
              </div>
            </div>
          ) : null
        }
        {
          type === 'Bearer' ? (
            <div className="fx1">
              <TextField
                label="Token"
                error={clicked && !trim(token)}
                value={token}
                onChange={(e) => {
                  setState({
                    token: e.target.value,
                  });
                }}
                disabled={!enabled || disableFullBlock}
              />
            </div>
          ) : null
        }
        {
          !type ? (
            <div
              className={`fx1 h56 r6 layoutRow fhaS fvaC c0 f14 b2 bs
                bcF.15 (b|)cF44336.error` + (clicked ? ' error' : '')}
            >Choose authorization type</div>
          ) : null
        }
      </div>
    </div>
  );
};
